module.exports = __webpack_public_path__ + "img/352.28e1c823.png";